/**
 * AdminParagonStyleBlock — Injects admin-only animation utilities
 * not covered by globals.css (which already provides ember-breathe,
 * glow-pulse, .ember-active, .glow-pulse, and scrollbar styles).
 */
export default function AdminParagonStyleBlock() {
  return (
    <style>{`
@keyframes pulse-dot { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:.45;transform:scale(.85)} }
@keyframes danger-border { 0%,100%{border-color:rgba(248,113,113,0.15)} 50%{border-color:rgba(248,113,113,0.35)} }
.ember-line { animation: ember-breathe 2.6s ease-in-out infinite; }
.glow-btn { animation: glow-pulse 2.8s ease-in-out infinite; }
.pulse-dot { animation: pulse-dot 1.8s ease-in-out infinite; }
.danger-border { animation: danger-border 1.8s ease-in-out infinite; }
@media (prefers-reduced-motion: reduce) {
  .ember-line, .glow-btn, .pulse-dot, .danger-border { animation: none; }
}
`}</style>
  )
}
